export enum KycFileType {
  Order = 'Order',
  Manual_KYC_Report = 'Manual_KYC_Report',
}
